define('services/composer/qualityService',[
    "lib/knockout",
    "jquery",
    "lib/lodash4",
    'models/composer/forms/QuestionType',
    'services/apiCore',
    'services/loggingService'
], function (
    ko,
    $,
    _,
    QuestionType,
    apiCore,
    loggingService
) {
    "use strict";

    return {
        post: {
            scoreEvaluation: function (unwrappedQualityManagementModel) {
                var endpoint = "/quality/evaluations/scoring";
                var data = unwrappedQualityManagementModel;

                // separate the evaluation form (questions) from the answers
                // iterate over question groups
                var originalQuestionGroups = data.questionGroups;
                var questionGroups = []; // stores the questions
                var questionGroupScores = []; // stores the answers
                _.forEach(originalQuestionGroups, function(originalQuestionGroup) {
                    // iterate over questions
                    var originalQuestions = originalQuestionGroup.questions;
                    var questions = []; // stores the questions
                    var questionScores = []; // stores the answers
                    _.forEach(originalQuestions, function(originalQuestion) {
                        if(originalQuestion.answerId !== "") {
                            // assemble question
                            var question = {
                                id: originalQuestion.id,
                                text: originalQuestion.text,
                                helpText: originalQuestion.helpText,
                                type: originalQuestion.type,
                                isKill: originalQuestion.isKill,
                                isCritical: originalQuestion.isCritical,
                                naEnabled: originalQuestion.naEnabled,
                                commentsRequired: originalQuestion.commentsRequired
                            };

                            question.answerOptions = originalQuestion.answerOptions;                            

                            questions.push(question); // add the question to the questionGroup

                            // assemble corresponding answer
                            questionScores.push({
                                questionId: originalQuestion.id,
                                answerId: originalQuestion.answerId,
                                markedNA: originalQuestion.naSelected,
                                comments: originalQuestion.comments
                            }); // add the answer to the questionScores
                        }
                    });

                    questionGroups.push({
                        type: "questionGroup",
                        id: originalQuestionGroup.id,
                        name: originalQuestionGroup.name,
                        naEnabled: originalQuestionGroup.naEnabled,
                        defaultAnswersToHighest: originalQuestionGroup.defaultAnswersToHighest,
                        defaultAnswersToNA: originalQuestionGroup.defaultAnswersToNA,
                        weight: originalQuestionGroup.weight,
                        questions: questions
                    });

                    questionGroupScores.push({
                        questionGroupId: originalQuestionGroup.id,
                        markedNA: originalQuestionGroup.naSelected,
                        questionScores: questionScores
                    });
                });

                // assemble questions
                var evalData = {
                    id: data.id,
                    type: data.type,
                    name: data.name,
                    notes: data.comments,
                    modifiedDate: (new Date()).toISOString(), /* send the current time as the modified date */
                    published: data.published,
                    contextId: data.contextId,
                    questionGroups: questionGroups
                };

                // assemble answers
                var answers = {
                    evaluationFormId: data.id,
                    questionGroupScores: questionGroupScores
                };

                // assemble questions and answers to send
                data = {
                    evaluationForm: evalData,
                    answers: answers
                };

                return apiCore.v2.post(endpoint, data).then(function (response) {
                    return response;
                }).catch(function (err) {
                    loggingService.error("QualityService Error: " + ((typeof err === 'string') ? err : JSON.stringify(err)));
                    throw err;
                });
            }
        }
    };
});

